
import React, { useEffect, useRef } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      window.location.replace("/");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        // strip hash and go to dashboard
        window.history.replaceState({}, document.title, "/dashboard");
        window.location.replace("/dashboard");
      } catch (e) {
        const status = e?.response?.status;
        const detail = e?.response?.data?.detail;
        if (status === 403 && detail) {
          // Redirect to login with a query-string flag for the message
          window.location.replace(`/?denied=${encodeURIComponent(detail)}`);
          return;
        }
        console.error("session exchange failed", e);
        window.location.replace("/");
      }
    })();
  }, [setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-xs tracking-[0.3em] uppercase text-zinc-500 animate-pulse">Signing you in…</div>
    </div>
  );
}
